module.exports = __webpack_public_path__ + "img/dsyz-icon.de610a9f.png";